import React from "react";
import useHover from "../hooks/useHover";
import { clamp } from "../misc/helperfuncs";

const NotText = ({
  place,
  hoverDescription,
  onSidebarClicked,
  resizingBoxes,
  sizePercentage,
}) => {
  const hover = useHover(hoverDescription);

  return (
    <div
      onClick={() => {
        if (onSidebarClicked) onSidebarClicked(place);
      }}
      {...hover.divProps}
      className="divColumn"
      style={{
        height: "100%",
        justifyContent: "center",
        cursor: "pointer",
        width: "100%",
      }}
    >
      {!hover.hover && (
        <div
          className="textBold"
          style={{
            color: hover.hover ? "gold" : "white",
            writingMode: "vertical-rl",
            textOrientation: "upright",
            marginBottom: "15px",
            fontSize: resizingBoxes
              ? `${clamp((20 / 100) * sizePercentage.total, 13, 25)}px`
              : "17px",
          }}
        >
          Not
        </div>
      )}
      <div
        className="textBold"
        style={{
          color: hover.hover ? "gold" : "white",
          writingMode: "vertical-rl",
          textOrientation: "upright",
          fontSize: resizingBoxes
            ? `${clamp((20 / 100) * sizePercentage.total, 13, 25)}px`
            : "17px",
        }}
      >
        {hover.hover ? (place == "Saved" ? "Save" : place) : place}
      </div>
      {hover.hoverDescription}
    </div>
  );
};

export default NotText;
